import React from "react";
import style from "css/landing.module.css";
import { ReactComponent as Arrow } from "asset/common/arrow.svg";
import NewsItem from "./newsItem";
import { Swiper, SwiperSlide } from "swiper/react";
import { Scrollbar } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { useMediaQuery } from "react-responsive";
import { sendEvent } from "analytics/ga4";

function News() {
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });

  const newsList = [
    {
      img: "img/landing/news/news_01.png",
      type: "Solution",
      title:
        "전북도청 하이브리드 워킹 시스템 (Hybrid Working System) all Place 구축!",
      date: "24.06.28",
    },
    {
      img: "img/landing/news/news_02.png",
      type: "SI",
      title:
        "한림대학교의료원 비대면 진료 시스템 : Zoom API 기반 영상회의 솔루션",
      date: "24.06.28",
    },
    {
      img: "img/landing/news/news_03.png",
      type: "SI",
      title: "제3차 민주주의 정상회의 Zoom 플랫폼 도입과 솔루션 적용 사례!",
      date: "24.06.28",
    },
    {
      img: "img/landing/news/news_04.png",
      type: "Solution",
      title:
        "HP Poly Connect Manager 최고의 혁신, 영상회의 솔루션을 경험해보세요!",
      date: "24.06.28",
    },
  ];
  return (
    <div className={style.news_wrap}>
      <div className={style.news_titlw_wrap}>
        <div className={style.news_text_wrap}>
          <div className={style.news_title}>
            <span>Riv</span>의 최신 소식들
          </div>
          <div className={style.news_text}>현재 진행 중인 우리의 소식들</div>
        </div>
        <button
          className={style.news_view_more_btn}
          onClick={() => { sendEvent("SNS", "click_outbound", "instagram_news"); window.open("https://www.instagram.com/rivtechnology/", "_blank"); }}
        >
          <span>View more</span>
          <Arrow
            fill="#0c1117"
            width="22px"
            height="22px"
          />
        </button>
      </div>

      <Swiper
        scrollbar={{ draggable: true }}
        slidesPerView={"auto"}
        spaceBetween={isMobile ? 10 : 50}
        centeredSlides={isMobile ? true : false}
        modules={[Scrollbar]}
        className={style.news_list_wrap}
        observer={true}
        observeParents={true}
        observeSlideChildren={true}
        grabCursor={true}
      >
        {newsList.map((news, index) => (
          <SwiperSlide
            className={style.news_item}
            key={index}
          >
            <NewsItem news={news} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default News;
